import type { MetricSeriesSpec } from './seriesTypes';

/**
 * Border colour and width per bar for `barOutlines`. A bar without its own outline keeps
 * the series-wide `barBorder`, or none: Chart.js reads a zero width as no border, which is
 * its bar default.
 */
export function perBarOutlines(
    series: MetricSeriesSpec,
    outlines: NonNullable<MetricSeriesSpec['barOutlines']>,
    barCount: number
): { borderColor: string[]; borderWidth: number[] } {
    const bars = Array.from({ length: barCount }, (_bar, index) => outlines.colors[index]);
    return {
        borderColor: bars.map((color) => color ?? series.barBorder?.color ?? series.color),
        borderWidth: bars.map((color) =>
            color === undefined ? (series.barBorder?.width ?? 0) : outlines.width
        ),
    };
}
